import { render } from "./orgManage.vue?vue&type=template&id=611b9584&scoped=true"
import script from "./orgManage.vue?vue&type=script&lang=js"
export * from "./orgManage.vue?vue&type=script&lang=js"

import "./orgManage.vue?vue&type=style&index=0&id=611b9584&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611b9584"]])

export default __exports__